import React, { useEffect, useState } from "react";
// import homeImage from "../../images/Artboard.png";
import { IoIosSkipForward } from "react-icons/io";

import coinImage from "../../images/CoinAnimation2.gif";
// import backgroundAudio from "../../audios/presentation.wav";
import { ToastContainer, toast } from "react-toastify";

import "../Home/Home.css";
import { useNavigate } from "react-router-dom";

export function Home() {
  const [redirectToPage, setRedirectToPage] = useState(false);
  //   const [isLogo, setIsLogo] = useState(true);

  const navigate = useNavigate();

  function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|iphone|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent.toLowerCase()
    );
  }

  useEffect(() => {
    const isSmallScreen = window.innerWidth <= 576;
    if (isMobile() && isSmallScreen) {
      toast.info(
        "For better experience, Please use a laptop or tablet screen.",
        {
          position: "top-right",
          autoClose: 10000,
        }
      );
    }

    const timer = setTimeout(() => {
      setRedirectToPage(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);
  const handleSkip = () => {
    navigate("/sign-up");
  };

  useEffect(() => {
    if (redirectToPage) {
      navigate("/sign-up");
    }
  }, [redirectToPage, navigate]);

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 cont">
            <div className="homeContainer relative">

              {/* Skip Button */}
              <div className="absolute bottom-6 lg:bottom-12 right-6 md:right-10">
                <button
                  onClick={handleSkip}
                  className="px-6 py-2 text-sm md:text-lg lg:text-xl rounded-full bg-black/60 text-white flex gap-1 items-center"
                >
                  <span>Skip</span>
                  <IoIosSkipForward />
                </button>
              </div>

              {/* Header Content */}
              <div className="homeContent">
                <h2>Dear Doctor,</h2>
                <h2>
                  Take a break and unwind with Find the ZOK, a fun and engaging
                  way to de-stress after a long shift.
                </h2>
              </div>

              {/* Image Section */}
              <div className="coinHome w-100 my-6 flex justify-center">
                <img
                  className="w-3/12 md:w-2/12 lg:w-1/12"
                  src={coinImage}
                  alt="coin"
                />
              </div>

              {/* Bottom Content */}
              <div className="titleButtom pb-8 lg:pb-0 text-white">
                <p>
                  Choose a puzzle and find up to 10 boxes of Betaloc ZOK within
                  30 seconds per theme. There are only 5 questions available. If
                  time is up during the game,
                </p>

                <p>
                  you can still get extra time by answering questions related to
                  the management of hypertensive patients with Ischemic Heart
                  Disease (IHDs) and beta-blockers.
                </p>

                <p>
                  The target is to get 200 coins by finding 20 boxes for both
                  themes.
                </p>

                {/* Footer Info */}
                <div className="d-flex justify-content-between align-items-end mt-4">
                  <p style={{ fontSize: "11px" }}>
                    AstraZeneca Near East Sweifieh, Bldg. 19, Al Haj Mousa Obaidat Street,
                    P.O. Box 17788, Zip Code 11195 Amman, Jordan Tel:
                    <a
                      href="tel:+96265827580"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "white" }}
                    >
                      {" "}+962 6 582 7580
                    </a>
                    <br />
                    For any adverse event report, product quality complaint or medical
                    information request related to AZ products,
                    <br />
                    you can complete the web-based form accessible 24/7 via:
                    <br />
                    <a
                      href="http://contactazmedical.astrazeneca.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "white" }}
                    >
                      http://contactazmedical.astrazeneca.com
                    </a>
                  </p>

                  <p style={{ fontSize: "11px" }}>
                    Powered by AstraZeneca <br /> Z6-6981 Expiry Date: Mar 2028 <br /> for health care professionals only
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}